angular.module('unica_tutorial.tutorial_routes', [
	'ui.router'
])

.config(function($stateProvider) {

	$stateProvider

		// TUTORIAL
		.state('app.tutorial', {
			url: '/tutorial',
			views: {
				'mainContent': {
					templateUrl: './modules/tutorial/templates/tutorial.html',
					controller: 'TutorialController'
				}
			},
			params: {
				need_auth: true
			},
			ncyBreadcrumb: {
				label: 'Tutorial'
			}
		});

});

